import fetchWrapper from '../../utils/api/fetchWrapper'
import { fetchPath } from '../../utils/api'
import { URL } from '../../constants/api'
import yodaFormatter from '../../utils/api/yodaFormatter'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import line from './line'

export default {
  namespaced: true,
  state,
  mutations,
  actions: actions({ fetch: fetchWrapper, apiUrl: URL, fetchPath, yodaFormatter }),
  modules: { line },
}
